<template>
  <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
    <div class="bg-violet-500 text-white rounded-xl p-6 shadow dark:shadow-lg flex flex-col justify-between">
      <div>
        <h2 class="text-lg font-semibold">Website Analytics</h2>
        <p class="text-sm opacity-80">Total 28.5% Conversion Rate</p>
      </div>
      <div class="mt-4 flex flex-wrap gap-4">
        <div class="bg-violet-600 rounded-lg px-4 py-2 text-center">
          <div class="font-bold text-lg">1.5k</div>
          <div class="text-xs">Sessions</div>
        </div>
        <div class="bg-violet-600 rounded-lg px-4 py-2 text-center">
          <div class="font-bold text-lg">3.1k</div>
          <div class="text-xs">Page Views</div>
        </div>
        <div class="bg-violet-600 rounded-lg px-4 py-2 text-center">
          <div class="font-bold text-lg">1.2k</div>
          <div class="text-xs">Leads</div>
        </div>
        <div class="bg-violet-600 rounded-lg px-4 py-2 text-center">
          <div class="font-bold text-lg">12%</div>
          <div class="text-xs">Conversions</div>
        </div>
      </div>
    </div>
    <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow dark:shadow-lg flex flex-col justify-between">
      <div class="text-gray-500 dark:text-gray-300 text-sm">Average Daily Sales</div>
      <div class="text-2xl font-bold mt-2 dark:text-white">$28,450</div>
      <div class="mt-4">
        <div class="h-16 w-full bg-gradient-to-r from-green-200 to-green-400 dark:from-green-700 dark:to-green-400 rounded-lg"></div>
      </div>
    </div>
    <div class="bg-white dark:bg-gray-800 rounded-xl p-6 shadow dark:shadow-lg flex flex-col justify-between">
      <div class="flex justify-between items-center">
        <div>
          <div class="text-gray-500 dark:text-gray-300 text-sm">Sales Overview</div>
          <div class="text-2xl font-bold dark:text-white">$42.5k</div>
        </div>
        <div class="text-green-500 font-semibold">+18.2%</div>
      </div>
      <div class="flex justify-between mt-4 text-xs">
        <div>Order<br><span class="font-bold text-base">62.2%</span></div>
        <div>Visits<br><span class="font-bold text-base">25.5%</span></div>
      </div>
      <div class="mt-2 h-2 w-full bg-violet-200 dark:bg-violet-700 rounded-full">
        <div class="h-2 bg-violet-500 dark:bg-violet-400 rounded-full" style="width: 62%"></div>
      </div>
    </div>
  </div>
</template> 